import { useParams } from "react-router-dom";
import { PrimeAlarmDetails } from "./prime";
import { HiAlarmDetails } from "./hi";
import { useTranslation } from "react-i18next";

export const AlarmDetails = () => {
  const { id } = useParams();
  const { t } = useTranslation();

  const loginType = localStorage.getItem("login_type");

  return (
    <div
      style={{
        padding: "2rem 1rem 0 1rem",
        width: "100%",
        height: "100%",
        overflowY: "auto",
      }}
    >
      <div
        style={{
          fontSize: "1.25rem",
          marginBottom: "0.5rem",
          fontWeight: "bold",
        }}
      >
        {t("prime.alarm.alarmDetail")}
      </div>
      {loginType === "prime" ? (
        <PrimeAlarmDetails alarmId={id} />
      ) : (
        <HiAlarmDetails alarmId={id} />
      )}
    </div>
  );
};
